import React, { useState } from "react";
import "./JoinAsReviewer.css";

export default function JoinAsReviewer() {
  const [formData, setFormData] = useState({
    fullName: "",
    qualification: "",
    institution: "",
    address: "",
    residentialContact: "",
    contactNumber: "",
    researchDomain: "",
    resume: null,
  });

  const [fileName, setFileName] = useState("No file chosen");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setFormData({ ...formData, resume: file });
    } else {
      setFileName("No file chosen");
      setFormData({ ...formData, resume: null });
    }
  };

  const validate = () => {
    let formErrors = {};
    const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;

    if (!formData.fullName.trim())
      formErrors.fullName = "Please enter your full name";
    if (!formData.qualification.trim())
      formErrors.qualification = "Please enter your qualification";
    if (!formData.institution.trim())
      formErrors.institution = "Please enter your institution/company name";
    if (!formData.address.trim())
      formErrors.address = "Please enter your institution/company address";
    if (!formData.residentialContact.trim())
      formErrors.residentialContact =
        "Please enter your residential contact details";
    if (
      !formData.contactNumber.trim() ||
      !phoneRegex.test(formData.contactNumber)
    )
      formErrors.contactNumber =
        "Please enter a valid contact number with country code";
    if (!formData.researchDomain.trim())
      formErrors.researchDomain =
        "Please enter your research domain/area of interest";

    if (!formData.resume) {
      formErrors.resume = "Please upload your resume in .doc or .docx format";
    } else {
      const fileExtension = formData.resume.name.split(".").pop().toLowerCase();
      if (fileExtension !== "doc" && fileExtension !== "docx") {
        formErrors.resume = "Please upload a .doc or .docx file";
      }
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      alert(
        "Form submitted successfully! Thank you for applying to be a reviewer."
      );
      setFormData({
        fullName: "",
        qualification: "",
        institution: "",
        address: "",
        residentialContact: "",
        contactNumber: "",
        researchDomain: "",
        resume: null,
      });
      setFileName("No file chosen");
      setErrors({});
    }
  };

  return (
    <div className="reviewer-registration-container">
      <div className="reviewer-registration-header">
        <h1>IJACNA Editorial Board Reviewer Confirmation</h1>
        <p>Join our team of expert reviewers</p>
      </div>

      <form className="reviewer-registration-form" onSubmit={handleSubmit}>
        <div className="reviewer-two-column-layout">
          {/* LEFT SIDE */}
          <div className="reviewer-left-column">
            {/* Personal Information */}
            <div className="reviewer-form-section">
              <h2 className="reviewer-form-section-title">
                Personal Information
              </h2>

              <div className="reviewer-form-group">
                <label htmlFor="fullName" className="reviewer-form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  id="fullName"
                  className={`reviewer-form-input ${
                    errors.fullName ? "error" : ""
                  }`}
                  placeholder="Enter your full name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
                {errors.fullName && (
                  <div className="reviewer-form-error">{errors.fullName}</div>
                )}
              </div>

              <div className="reviewer-form-group">
                <label htmlFor="qualification" className="reviewer-form-label">
                  Qualification
                </label>
                <input
                  type="text"
                  id="qualification"
                  className={`reviewer-form-input ${
                    errors.qualification ? "error" : ""
                  }`}
                  placeholder="Enter your qualifications"
                  value={formData.qualification}
                  onChange={handleChange}
                />
                {errors.qualification && (
                  <div className="reviewer-form-error">
                    {errors.qualification}
                  </div>
                )}
              </div>
            </div>

            {/* Professional Information */}
            <div className="reviewer-form-section">
              <h2 className="reviewer-form-section-title">
                Professional Information
              </h2>

              <div className="reviewer-form-group">
                <label htmlFor="institution" className="reviewer-form-label">
                  Institution/Company Name
                </label>
                <input
                  type="text"
                  id="institution"
                  className={`reviewer-form-input ${
                    errors.institution ? "error" : ""
                  }`}
                  placeholder="Enter institution/company name"
                  value={formData.institution}
                  onChange={handleChange}
                />
                {errors.institution && (
                  <div className="reviewer-form-error">
                    {errors.institution}
                  </div>
                )}
              </div>

              <div className="reviewer-form-group">
                <label htmlFor="address" className="reviewer-form-label">
                  Address of Institution/Company
                </label>
                <input
                  type="text"
                  id="address"
                  className={`reviewer-form-input ${
                    errors.address ? "error" : ""
                  }`}
                  placeholder="Enter institution/company address"
                  value={formData.address}
                  onChange={handleChange}
                />
                {errors.address && (
                  <div className="reviewer-form-error">{errors.address}</div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="reviewer-right-column">
            {/* Contact Information */}
            <div className="reviewer-form-section">
              <h2 className="reviewer-form-section-title">
                Contact Information
              </h2>

              <div className="reviewer-form-group">
                <label
                  htmlFor="residentialContact"
                  className="reviewer-form-label"
                >
                  Residential Contact Details
                </label>
                <input
                  type="text"
                  id="residentialContact"
                  className={`reviewer-form-input ${
                    errors.residentialContact ? "error" : ""
                  }`}
                  placeholder="Enter residential contact details"
                  value={formData.residentialContact}
                  onChange={handleChange}
                />
                {errors.residentialContact && (
                  <div className="reviewer-form-error">
                    {errors.residentialContact}
                  </div>
                )}
              </div>

              <div className="reviewer-form-group">
                <label htmlFor="contactNumber" className="reviewer-form-label">
                  Contact Number with Country Code
                </label>
                <input
                  type="text"
                  id="contactNumber"
                  className={`reviewer-form-input ${
                    errors.contactNumber ? "error" : ""
                  }`}
                  placeholder="e.g., +1 123 456 7890"
                  value={formData.contactNumber}
                  onChange={handleChange}
                />
                {errors.contactNumber && (
                  <div className="reviewer-form-error">
                    {errors.contactNumber}
                  </div>
                )}
              </div>
            </div>

            {/* Research Information */}
            <div className="reviewer-form-section">
              <h2 className="reviewer-form-section-title">
                Research Information
              </h2>

              <div className="reviewer-form-group">
                <label htmlFor="researchDomain" className="reviewer-form-label">
                  Research Domain Name/Area of Interest
                </label>
                <input
                  type="text"
                  id="researchDomain"
                  className={`reviewer-form-input ${
                    errors.researchDomain ? "error" : ""
                  }`}
                  placeholder="Enter your research domain/area of interest"
                  value={formData.researchDomain}
                  onChange={handleChange}
                />
                {errors.researchDomain && (
                  <div className="reviewer-form-error">
                    {errors.researchDomain}
                  </div>
                )}
              </div>

              <div className="reviewer-form-group">
                <label className="reviewer-form-label">
                  Upload your Resume (.doc or .docx)
                </label>
                <div className="reviewer-file-upload">
                  <input
                    type="file"
                    id="resume"
                    className="reviewer-file-input"
                    accept=".doc,.docx"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="resume" className="reviewer-file-label">
                    <span>Choose File</span>
                    <span className="reviewer-file-name">{fileName}</span>
                  </label>
                </div>
                {errors.resume && (
                  <div className="reviewer-form-error">{errors.resume}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <button type="submit" className="reviewer-submit-btn">
          Submit
        </button>
        <div className="reviewer-required-note">* Required fields</div>
      </form>
    </div>
  );
}
